"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var colors_1 = require("../colors");
var light = {
    palette: {
        text: {
            default: colors_1.colors.solid.vulcan,
            secondary: colors_1.colors.solid.vulcanLightest,
            tertiary: colors_1.colors.solid.ghostLight,
            contrast: colors_1.colors.solid.zircon
        },
        background: {
            default: colors_1.colors.solid.zircon,
            secondary: colors_1.colors.solid.zirconDarkest,
            tertiary: colors_1.colors.solid.white,
            alternate: colors_1.colors.solid.vulcan,
            contrast: colors_1.colors.solid.vulcanLight
        },
        border: {
            default: colors_1.colors.solid.ghostLight,
            secondary: colors_1.colors.solid.mystic,
            tertiary: colors_1.colors.solid.alto,
            contrast: colors_1.colors.solid.vulcanLightest
        }
    }
};
exports.default = light;
//# sourceMappingURL=light.js.map